import { useEffect, useState } from "react";

import {
  getGoldBotStatus,
  isGoldBotRequestCanceled,
} from "../services/goldBotApi";

export const GOLD_BOT_POLL_INTERVAL_MS = 5000;

export function useGoldBotStatus() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isActive = true;
    let activeController = null;

    const loadStatus = async () => {
      activeController?.abort();
      const controller = new AbortController();
      activeController = controller;

      try {
        const status = await getGoldBotStatus({
          signal: controller.signal,
        });
        if (isActive) {
          setData(status);
          setError(null);
        }
      } catch (requestError) {
        if (isActive && !isGoldBotRequestCanceled(requestError)) {
          setError(requestError);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    loadStatus();
    const pollInterval = window.setInterval(
      loadStatus,
      GOLD_BOT_POLL_INTERVAL_MS
    );

    return () => {
      isActive = false;
      window.clearInterval(pollInterval);
      activeController?.abort();
    };
  }, []);

  return { data, error, isLoading };
}
